import $ from 'jquery';
import 'slick-carousel';

$('.dsp-accordion').each(function () {
  const $group = $(this);

  $group.find('.accordion-link').on('click', function (e) {
    e.preventDefault();

    const wasActive = $(this).hasClass('is-active') && $(this).data('self-collapse') != undefined;

    // hide all panes, deactivate all tabs (temporarily)
    $group.find('.accordion-link').removeClass('is-active');
    $group.find('.accordion-pane').removeClass('is-active');
    $group.find('.accordion-nav').removeClass('is-active');
    $group.find('.accordion-nav').attr('aria-expanded', false);

    if (!wasActive) {
      // get the pane to be activated
      const $control = $(this);
      const $pane = $($(this).attr('href'));

      // position any slider
      if ($pane.data('slider')) {
        setTimeout(() => {
          $(`.${$pane.data('slider')}`).slick('setPosition');
        }, 10);
      }
      // show this pane
      $control.addClass('is-active');
      $pane.addClass('is-active');

      // activate this tab
      $pane.parents('.accordion-nav').addClass('is-active');
      $pane.parents('.accordion-nav').attr('aria-expanded', true);
    }
  });
});
